import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AgentWhitelist";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const CasinoReport = () => {
  // ==========================================
  // SIDEBAR
  // ==========================================
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );

  // ==========================================
  // DATA
  // ==========================================
  const [casino, setCasino] = useState([]);
  const [fullCasino, setFullCasino] = useState([]);

  // ==========================================
  // FILTER
  // ==========================================
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // ==========================================
  // TOTALS
  // ==========================================
  const [bets, setBets] = useState(0);
  const [wins, setWins] = useState(0);
  const [ggr, setGgr] = useState(0);

  // ==========================================
  // PAGINATION
  // ==========================================
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 50;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem =
    indexOfLastItem - itemsPerPage;

  // ONLY FOR TABLE DISPLAY
  const currentItems = casino.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(
    casino.length / itemsPerPage
  );

  // ==========================================
  // SIDEBAR
  // ==========================================
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // ==========================================
  // CALCULATE TOTALS
  // ==========================================
  const calculateTotals = (data) => {
    let totalBet = 0;
    let totalWin = 0;
    let totalGgr = 0;

    data.forEach((row) => {
      totalBet += Number(row.amount) || 0;
      totalWin += Number(row.profit) || 0;
      totalGgr += Number(row.ggr) || 0;
    });

    setBets(totalBet.toFixed(2));
    setWins(totalWin.toFixed(2));
    setGgr(totalGgr.toFixed(2));
  };

  // ==========================================
  // FETCH DATA
  // ==========================================
  const casinoData = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        `${base_url}/api/webapi/casinoData`,
        {
          headers: {
            Authorization: auth,
            "content-type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        const data = response?.data?.result || [];

        console.log("Total API records:", data.length);

        // Complete API data
        setFullCasino(data);

        // Initially display all
        setCasino(data);

        // Calculate initial totals
        calculateTotals(data);
      }
    } catch (error) {
      console.error("Casino API Error:", error);
    }
  };

  // ==========================================
  // SEARCH
  // ==========================================
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // ==========================================
  // PARSE ROW DATE
  // ==========================================
  const parseCasinoDate = (time) => {
    if (!time) return null;

    try {
      /*
        Expected:

        2025/08/26 05:06:40 PM
      */

      const parts = String(time).trim().split(" ");

      if (parts.length < 3) {
        return null;
      }

      const datePart = parts[0];
      const timePart = parts[1];
      const ampm = parts[2];

      const dateParts = datePart.split("/");

      if (dateParts.length !== 3) {
        return null;
      }

      const yyyy = Number(dateParts[0]);
      const mm = Number(dateParts[1]);
      const dd = Number(dateParts[2]);

      let timeParts = timePart.split(":");

      let hh = Number(timeParts[0]);
      let min = Number(timeParts[1]);
      let ss = Number(timeParts[2]);

      if (ampm === "PM" && hh !== 12) {
        hh += 12;
      }

      if (ampm === "AM" && hh === 12) {
        hh = 0;
      }

      return new Date(
        yyyy,
        mm - 1,
        dd,
        hh,
        min,
        ss
      );
    } catch (error) {
      console.error("Date parse error:", time);
      return null;
    }
  };

  // ==========================================
  // FILTER
  // ==========================================
  const handleFilter = () => {
    let filteredData = [...fullCasino];

    // ----------------------------------------
    // PLAYER / CUSTOMER / AGENT SEARCH
    // ----------------------------------------
    if (search.trim() !== "") {
      const searchValue = search
        .trim()
        .toLowerCase();

      filteredData = filteredData.filter((row) => {
        const playerId = String(
          row.playerId || ""
        ).toLowerCase();

        const customerId = String(
          row.customerId || ""
        ).toLowerCase();

        const agentId = String(
          row.agentId || ""
        ).toLowerCase();

        return (
          playerId.includes(searchValue) ||
          customerId.includes(searchValue) ||
          agentId.includes(searchValue)
        );
      });
    }

    // ----------------------------------------
    // DATE FILTER
    // ----------------------------------------
    if (startDate || endDate) {
      let start = null;
      let end = null;

      if (startDate) {
        start = new Date(
          `${startDate}T00:00:00`
        );
      }

      if (endDate) {
        end = new Date(
          `${endDate}T23:59:59.999`
        );
      }

      filteredData = filteredData.filter((row) => {
        const rowDate = parseCasinoDate(row.time);

        if (!rowDate) {
          return false;
        }

        if (start && rowDate < start) {
          return false;
        }

        if (end && rowDate > end) {
          return false;
        }

        return true;
      });
    }

    console.log(
      "Filtered records:",
      filteredData.length
    );

    // THIS CONTAINS ALL FILTERED DATA
    setCasino(filteredData);

    // Update totals according to filtered data
    calculateTotals(filteredData);

    // Always go back to page 1
    setCurrentPage(1);
  };

  // ==========================================
  // RESET
  // ==========================================
  const resetFilters = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");

    setCasino(fullCasino);

    calculateTotals(fullCasino);

    setCurrentPage(1);
  };

  // ==========================================
  // FORMAT DATE
  // ==========================================
  const formatDate = (date) => {
    const year = date.getFullYear();

    const month = String(
      date.getMonth() + 1
    ).padStart(2, "0");

    const day = String(
      date.getDate()
    ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // ==========================================
  // TODAY
  // ==========================================
  const setToday = () => {
    const today = new Date();

    const date = formatDate(today);

    setStartDate(date);
    setEndDate(date);
  };

  // ==========================================
  // YESTERDAY
  // ==========================================
  const setYesterday = () => {
    const yesterday = new Date();

    yesterday.setDate(
      yesterday.getDate() - 1
    );

    const date = formatDate(yesterday);

    setStartDate(date);
    setEndDate(date);
  };

  // ==========================================
  // THIS WEEK
  // ==========================================
  const setThisWeek = () => {
    const today = new Date();

    const day = today.getDay();

    const diff = day === 0 ? 6 : day - 1;

    const monday = new Date(today);

    monday.setDate(
      today.getDate() - diff
    );

    setStartDate(formatDate(monday));
    setEndDate(formatDate(today));
  };

  // ==========================================
  // THIS MONTH
  // ==========================================
  const setThisMonth = () => {
    const today = new Date();

    const firstDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );

    setStartDate(formatDate(firstDay));
    setEndDate(formatDate(today));
  };

  // ==========================================
  // DOWNLOAD COMPLETE FILTERED REPORT
  // ==========================================
  const downloadReport = () => {
    try {
      /*
       * VERY IMPORTANT
       *
       * DO NOT USE currentItems HERE.
       *
       * currentItems = current 50 rows
       *
       * casino = ALL FILTERED ROWS
       */

      const reportData = [...casino];

      console.log(
        "Downloading records:",
        reportData.length
      );

      if (reportData.length === 0) {
        alert(
          "No records available for download."
        );
        return;
      }

      // ======================================
      // CREATE PDF
      // ======================================

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      // ======================================
      // TITLE
      // ======================================

      doc.setFontSize(16);

      doc.text(
        "Casino Bets Report",
        10,
        12
      );

      // ======================================
      // FILTER DETAILS
      // ======================================

      doc.setFontSize(8);

      let filterText = "All Data";

      if (startDate && endDate) {
        filterText =
          `Date: ${startDate} to ${endDate}`;
      } else if (startDate) {
        filterText =
          `From: ${startDate}`;
      } else if (endDate) {
        filterText =
          `Up To: ${endDate}`;
      }

      if (search.trim()) {
        filterText +=
          ` | Search: ${search}`;
      }

      doc.text(
        filterText,
        10,
        18
      );

      // ======================================
      // SUMMARY
      // ======================================

      doc.text(
        `Total Records: ${reportData.length}`,
        10,
        25
      );

      doc.text(
        `Total Bets: ${bets}`,
        65,
        25
      );

      doc.text(
        `Total Wins: ${wins}`,
        115,
        25
      );

      doc.text(
        `Total GGR: ${ggr}`,
        165,
        25
      );

      // ======================================
      // CONVERT DATA
      // ======================================

      const tableRows = reportData.map(
        (row) => {
          let winAmount = 0;

          if (Number(row.profit) > 0) {
            winAmount =
              Number(row.profit) -
              Number(row.amount || 0);
          } else {
            winAmount =
              Number(row.profit) || 0;
          }

          let status = "Rollback";

          if (Number(row.status) === 1) {
            status = "Win";
          }

          if (Number(row.status) === 2) {
            status = "Loss";
          }

          return [
            String(row.playerId || ""),
            String(row.gameId || ""),
            String(row.roundId || ""),
            Number(row.amount || 0).toFixed(2),
            Number(row.ggr || 0).toFixed(2),
            Number(winAmount || 0).toFixed(2),
            Number(
              row.old_balance || 0
            ).toFixed(2),
            Number(
              row.balance || 0
            ).toFixed(2),
            status,
            String(row.time || ""),
            String(row.result_time || ""),
          ];
        }
      );

      // ======================================
      // PDF TABLE
      // ======================================

      autoTable(doc, {
        startY: 30,

        head: [
          [
            "Player ID",
            "Game",
            "Game Round",
            "Bet Amount",
            "GGR",
            "Win Amount",
            "Before Balance",
            "After Balance",
            "Status",
            "Time",
            "Result Time",
          ],
        ],

        body: tableRows,

        theme: "grid",

        styles: {
          fontSize: 5.5,
          cellPadding: 1.2,
          overflow: "linebreak",
          valign: "middle",
        },

        headStyles: {
          fontSize: 6,
          halign: "center",
          valign: "middle",
        },

        bodyStyles: {
          halign: "center",
        },

        margin: {
          top: 30,
          left: 4,
          right: 4,
          bottom: 10,
        },

        // Repeat header on every PDF page
        showHead: "everyPage",

        // Footer
        didDrawPage: (data) => {
          const pageWidth =
            doc.internal.pageSize.width;

          const pageHeight =
            doc.internal.pageSize.height;

          doc.setFontSize(7);

          doc.text(
            `Page ${data.pageNumber}`,
            pageWidth - 25,
            pageHeight - 5
          );
        },
      });

      // ======================================
      // FILE NAME
      // ======================================

      let fileName = "casino-report";

      if (startDate && endDate) {
        fileName +=
          `_${startDate}_to_${endDate}`;
      } else {
        fileName += "_all-data";
      }

      if (search.trim()) {
        fileName +=
          `_${search.trim()}`;
      }

      fileName += ".pdf";

      // ======================================
      // SAVE
      // ======================================

      doc.save(fileName);

      console.log(
        "PDF generated successfully:",
        fileName
      );
    } catch (error) {
      console.error(
        "PDF ERROR:",
        error
      );

      alert(
        "PDF generation failed. Please check the browser console."
      );
    }
  };

  // ==========================================
  // INITIAL LOAD
  // ==========================================
  useEffect(() => {
    casinoData();
  }, []);

  // ==========================================
  // APPLY FILTER
  // ==========================================
  useEffect(() => {
    if (fullCasino.length > 0) {
      handleFilter();
    }
  }, [
    search,
    startDate,
    endDate,
  ]);

  // ==========================================
  // RESET PAGE ON FILTER
  // ==========================================
  useEffect(() => {
    setCurrentPage(1);
  }, [
    search,
    startDate,
    endDate,
  ]);

  // ==========================================
  // WINDOW RESIZE
  // ==========================================
  useEffect(() => {
    const handleResize = () => {
      const mobile =
        window.innerWidth < 768;

      setIsMobile(mobile);

      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  // ==========================================
  // UI
  // ==========================================
  return (
    <div className="wrapper bg-light">

      {/* SIDEBAR */}
      <AdminSidebar
        isSidebarOpen={
          isSidebarOpen
        }
        toggleSidebar={
          toggleSidebar
        }
        isMobile={isMobile}
      />

      {/* HEADER */}
      <AdminHeader
        toggleSidebar={
          toggleSidebar
        }
        isSidebarOpen={
          isSidebarOpen
        }
        isMobile={isMobile}
      />

      {/* CONTENT */}
      <div
        className={`content-wrapper p-1 ${
          !isMobile &&
          isSidebarOpen
            ? ""
            : "open-content-wrapper"
        }`}
        style={{
          marginLeft:
            !isMobile &&
            isSidebarOpen
              ? ""
              : "0",
        }}
      >

        <div
          className={`main-content ${
            isSidebarOpen
              ? "with-sidebar"
              : ""
          }`}
        >

          <div className="container-fluid py-4">

            {/* ================================= */}
            {/* HEADER */}
            {/* ================================= */}

            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">

              <h3 className="text-dark mb-0">
                🎰 Casino Bets Report
              </h3>

              <button
                type="button"
                className="btn btn-danger"
                onClick={
                  downloadReport
                }
                disabled={
                  casino.length === 0
                }
              >
                📄 Download Report
              </button>

            </div>

            {/* ================================= */}
            {/* SEARCH + CUSTOM DATE */}
            {/* ================================= */}

            <div className="row g-3 mb-3">

              {/* SEARCH */}

              <div className="col-md-3">

                <input
                  type="text"
                  placeholder="Player ID / Customer ID / Agent ID"
                  className="form-control"
                  value={search}
                  onChange={
                    handleSearch
                  }
                />

              </div>

              {/* START DATE */}

              <div className="col-md-2">

                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) =>
                    setStartDate(
                      e.target.value
                    )
                  }
                />

              </div>

              {/* END DATE */}

              <div className="col-md-2">

                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) =>
                    setEndDate(
                      e.target.value
                    )
                  }
                />

              </div>

              {/* RESET */}

              <div className="col-md-2">

                <button
                  type="button"
                  className="btn btn-outline-secondary w-100"
                  onClick={
                    resetFilters
                  }
                >
                  Reset
                </button>

              </div>

            </div>

            {/* ================================= */}
            {/* DATE FILTER BUTTONS */}
            {/* ================================= */}

            {/* <div className="d-flex flex-wrap gap-2 mb-4">

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={
                  setToday
                }
              >
                Today
              </button>

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={
                  setYesterday
                }
              >
                Yesterday
              </button>

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={
                  setThisWeek
                }
              >
                This Week
              </button>

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={
                  setThisMonth
                }
              >
                This Month
              </button>

            </div> */}

            {/* ================================= */}
            {/* SUMMARY */}
            {/* ================================= */}

            <div className="d-flex justify-content-between flex-wrap gap-3 mb-4">

              <div className="card p-3">

                <strong>
                  Total Bets
                </strong>

                <span className="text-primary">
                  {bets || 0}
                </span>

              </div>

              <div className="card p-3">

                <strong>
                  Total Wins
                </strong>

                <span className="text-success">
                  {wins || 0}
                </span>

              </div>

              <div className="card p-3">

                <strong>
                  Total GGR
                </strong>

                <span className="text-danger">
                  {ggr || 0}
                </span>

              </div>

              <div className="card p-3">

                <strong>
                  Total Records
                </strong>

                <span>
                  {casino.length}
                </span>

              </div>

            </div>

            {/* ================================= */}
            {/* TABLE */}
            {/* ================================= */}

            {casino.length === 0 ? (

              <div className="text-center py-5 text-muted">
                No Casino Bets Found
              </div>

            ) : (

              <div className="table-responsive shadow-sm rounded bg-white p-3 w-100">

                <table className="table-hover align-middle mb-0 w-100">

                  <thead
                    style={{
                      backgroundColor:
                        "#182848",
                      color: "white",
                    }}
                  >

                    <tr className="text-center text-nowrap border border-black">

                      <th className="px-3">
                        Player ID
                      </th>

                      <th className="px-3">
                        Game
                      </th>

                      <th className="px-3">
                        Game Round
                      </th>

                      <th className="px-3">
                        Bet Amount
                      </th>

                      <th className="px-3">
                        GGR
                      </th>

                      <th className="px-3">
                        Win Amount
                      </th>

                      <th className="px-3">
                        Before Balance
                      </th>

                      <th className="px-3">
                        After Balance
                      </th>

                      <th className="px-3">
                        Status
                      </th>

                      <th className="px-3">
                        Time
                      </th>

                      <th className="px-3">
                        Result Time
                      </th>

                    </tr>

                  </thead>

                  <tbody>

                    {currentItems.map(
                      (row) => (

                        <tr
                          key={row.id}
                          className="text-center text-nowrap border border-dark"
                        >

                          <td className="px-3 py-2">
                            {row.playerId}
                          </td>

                          <td className="px-3">
                            {row.gameId}
                          </td>

                          <td className="px-3">
                            {row.roundId}
                          </td>

                          <td className="px-3">
                            {Number(
                              row.amount || 0
                            ).toFixed(2)}
                          </td>

                          <td className="px-3 text-danger">
                            {Number(
                              row.ggr || 0
                            ).toFixed(2)}
                          </td>

                          <td className="px-3 text-success">

                            {Number(
                              row.profit
                            ) > 0
                              ? (
                                  Number(
                                    row.profit
                                  ) -
                                  Number(
                                    row.amount ||
                                      0
                                  )
                                ).toFixed(2)
                              : Number(
                                  row.profit ||
                                    0
                                ).toFixed(2)}

                          </td>

                          <td className="px-3">
                            {Number(
                              row.old_balance ||
                                0
                            ).toFixed(2)}
                          </td>

                          <td className="px-3">
                            {Number(
                              row.balance ||
                                0
                            ).toFixed(2)}
                          </td>

                          <td className="px-3">

                            {Number(
                              row.status
                            ) === 1 ? (

                              <span className="badge bg-success">
                                Win
                              </span>

                            ) : Number(
                                row.status
                              ) === 2 ? (

                              <span className="badge bg-danger">
                                Loss
                              </span>

                            ) : (

                              <span className="badge bg-success">
                                Rollback
                              </span>

                            )}

                          </td>

                          <td className="px-3">
                            {row.time}
                          </td>

                          <td className="px-3">
                            {row.result_time}
                          </td>

                        </tr>

                      )
                    )}

                  </tbody>

                </table>

                {/* ================================= */}
                {/* PAGINATION */}
                {/* ================================= */}

                <div className="d-flex justify-content-center align-items-center mt-3 gap-2">

                  <button
                    type="button"
                    className="btn btn-sm btn-dark"
                    disabled={
                      currentPage === 1
                    }
                    onClick={() =>
                      setCurrentPage(
                        (prev) =>
                          prev - 1
                      )
                    }
                  >
                    Prev
                  </button>

                  <span className="btn btn-sm btn-light">
                    Page{" "}
                    {currentPage}{" "}
                    of{" "}
                    {totalPages}
                  </span>

                  <button
                    type="button"
                    className="btn btn-sm btn-dark"
                    disabled={
                      currentPage ===
                      totalPages
                    }
                    onClick={() =>
                      setCurrentPage(
                        (prev) =>
                          prev + 1
                      )
                    }
                  >
                    Next
                  </button>

                </div>

              </div>

            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default CasinoReport;